// ChatActions — the inline quick-action buttons under an agent chat message.
//
// Renders a message's `actions` array (e.g. "Open Intake Queue", "View
// Receiving Log") as `qa-btn` buttons. Behaviour is owned by the caller via
// `onAction`; this component is purely presentational.

import React from 'react';

export interface ChatAction {
  label: string;
  fn?: () => void;   // direct handler (navigate, open panel, …)
  text?: string;     // or: send this text as a user message
  [key: string]: any;
}

export function ChatActions({ actions, onAction }: {
  actions?: ChatAction[];
  onAction: (action: ChatAction) => void;
}) {
  if (!actions || actions.length === 0) return null;
  return (
    <div className="flex flex-wrap gap-2 mt-2.5">
      {actions.map((a, i) => (
        <button key={i} className="qa-btn" onClick={() => onAction(a)}>{a.label}</button>
      ))}
    </div>
  );
}
